import React from "react";
import { FormattedMessage } from "react-intl";
import { commonMessages } from "../translations/commonMessages";

const userTabLinks = [
  {
    title: (
      <FormattedMessage
        id={"goToLegacyNotes"}
        defaultMessage="Legacy Secure Notes"
      />
    ),
    href: "/legacy_notes"
  },
  {
    title: <FormattedMessage id={"profile"} defaultMessage="Profile" />,
    href: "/profile2"
  },
  {
    title: <FormattedMessage id={"appPortal"} defaultMessage="App Portal" />,
    href: "/portal"
  },
  {
    title: <FormattedMessage {...commonMessages.revertToAdmin} />,
    href: `/sessions/revert`,
    visible: state => state.user.assumedByAdmin
  },
  {
    title: <FormattedMessage {...commonMessages.revertToSuperadmin} />,
    href: `/admin/accounts/revert`,
    visible: state => state.user.assumedBySuperadmin
  },
  {
    title: <FormattedMessage {...commonMessages.revertToAdmin} />,
    href: `/sandboxes/revert`,
    visible: state => state.user.assumedBySandbox
  },
  {
    title: <FormattedMessage {...commonMessages.logout} />,
    href: "/logout"
  }
];

const userTabLinksSelector = state =>
  userTabLinks
    .filter(link => (link.visible ? link.visible(state) : true))
    .map(({ title, href, divider }) => {
      return { title, href, divider };
    });

export default userTabLinksSelector;
